import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class Label extends DesigntimeComponent {
    static staticName = "Label (Testing)";
    static staticId = "label";

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {
            labelText: { value: "Default text" },
            buttontext: { value: "Next" }
        };
    }

    getRuntimeView(context) {
        var view = $("<div></div>");
        view.append($("<label>" + this.values.labelText.value + "</label>"))
        return view;
    }
}

export { Label }
